import { Extension } from '@tiptap/core'
import { Plugin, PluginKey } from 'prosemirror-state'

export const MenuHandler = Extension.create({
    name: 'menuHandler',
    
    addOptions() {
        return {
            onSelectionChange: () => {},
        }
    },
    
    addProseMirrorPlugins() {
        const { options } = this;
        
        return [
            new Plugin({
                key: new PluginKey('menuHandler'),
                view() {
                    return {
                        update(view, prevState) {
                            // Check if selection has changed
                            if (!prevState || !prevState.selection.eq(view.state.selection)) {
                                if (options.onSelectionChange) {
                                    options.onSelectionChange(view.state.selection);
                                }
                            }
                        }
                    }
                }
            })
        ]
    }
})